import CardBackup from "components/Cards/CardBackup";
import React from "react";

const BackupData = () => {
  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <CardBackup />
        </div>
      </div>
    </div>
  );
};

export default BackupData;
